import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Alert } from 'reactstrap';
import { UncontrolledTooltip } from 'reactstrap';
import Moment from 'react-moment';
import { getRooms } from '../../models/room';
import { getSections } from '../../models/section';
import { getAttendants } from '../../models/attendant';
import ReactSVG from 'react-svg';
import iconExcludedAttendant from "../../assets/images/icon-excluded-attendant.svg";
import { getReservations } from '../../models/reservation';
import SignalR from '../../components/signalr';
import moment from 'moment';
import NotificationSoundFile from './../../assets/sounds/notification.mp3';
import Loader from '../../components/snippets/loader';
import { SettingsContext } from '../../components/context';
import { statuses } from '../../global-props';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { updateRoomStatus } from '../../models/room';
import AttendantListView from '../attendant/partials/attendantList';
class ReceptionAttendantTasksView extends Component {
  static contextType = SettingsContext;
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoadedRooms: false,
      isLoadedReservations: false,
      errorReservations: null,
      modal: false,
      selectedRoom: null,
      supplyRequests: null,
      selectedAttendant: null,
      attendants: null,
      attendantRooms: null,
      time: moment().format(),
      allAttendants: null,
    };
    this.notificationSound = new Audio(NotificationSoundFile);
    this.playNotificationSound = this.playNotificationSound.bind(this);
    this.handleChangeStatus = this.handleChangeStatus.bind(this);
  }
  componentDidMount() {
    this.retrieveReservations();
    this.retrieveSections();
    this.setUpTick();
  }
  setUpTick() {
    this.intervalID = setInterval(
      () => this.tick(),
      1000
    );
  }
  tick() {
    this.setState({
      time: moment().format(),
    });
  }
  componentWillUnmount() {
    clearInterval(this.intervalID);
    clearTimeout(this.resreservationListTimer);
  }
  retrieveAttendants() {
    getAttendants(true)
      .then(result => {
        let selectedAttendantId = localStorage.getItem('selectedAttendant');
        let selectedAttendant = selectedAttendantId?result.find(s=>s.id===parseInt(selectedAttendantId)):null;
        if ( this.state.sections.filter(section=>section.attendant&&selectedAttendant&&section.attendant.id===selectedAttendant.id).length===0 ) {
          selectedAttendant = null;
          localStorage.removeItem('selectedAttendant');
        }
        this.setState({
          allAttendants: result,
          selectedAttendant,
        }, () => this.retrieveRooms())
      }, error => {
        this.setState({error});
      });
  }
  retrieveRooms() {
    getRooms()
      .then(
        result => {
          let rooms = result;
          this.processRooms(rooms);
        },
        error => {
          this.setState({
            isLoadedRooms: false,
            error
          });
        }
      );
  }
  processRooms(rooms) {
    const {settings} = this.context;
    let attendantRooms = rooms;
    let selectedAttendant = this.state.selectedAttendant;
    if ( selectedAttendant!==null && !this.state.showAllReservations ) {
      attendantRooms = rooms.filter(room => room.section.attendant!==null && room.section.attendant.id===selectedAttendant.id);
    }
    let supplies = attendantRooms.map((room, i) => {
      let hasActiveRequest = false;
      if ( room.reservation!=null ) {
        room.reservation.supplies.forEach((supply) => {
          if (supply.status === 'open') { hasActiveRequest = true; }
          supply.isOverTime = moment.duration(moment(this.state.time).subtract(settings&&settings.offset&&settings.offset.value,'seconds').diff(supply.dateRequested)).asMinutes()>settings.waitingForSuppliesMinutes.value;
          supply.overTimeMinutes = supply.isOverTime?moment.duration(moment(this.state.time).subtract(settings.waitingForSuppliesMinutes.value, 'minute').subtract(settings&&settings.offset&&settings.offset.value,'seconds').diff(supply.dateRequested)).asMinutes():null;
        });
        room.reservation.room = { id: room.id, section: room.section };
        if (room.effectiveStatus==='ReadyForMikvah'||room.effectiveStatus==='ReadyForMikvahNext') {
          room.isOverTime = moment.duration(moment(this.state.time).subtract(settings&&settings.offset&&settings.offset.value,'seconds').diff(room.effectiveStatusLastChange)).asMinutes()>settings.readyForMikvahMinutes.value;
          room.overTimeMinutes = room.isOverTime?moment.duration(moment(this.state.time).subtract(settings.readyForMikvahMinutes.value, 'minute').subtract(settings&&settings.offset&&settings.offset.value,'seconds').diff(room.effectiveStatusLastChange)).asMinutes():null;
        }
      }
      return hasActiveRequest ? room.reservation : null;
    }).filter(room => room!=null);
    this.setState({
      isLoadedRooms: true,
      supplyRequests: supplies,
      error: null,
      rooms: rooms,
      attendantRooms: attendantRooms,
      savedRoomTime: moment().format()
    });
  }
  retrieveSections() {
    getSections()
      .then(
        result => {
          let attendants = result.map((section) => {
            return section.attendant;
          }).filter((attendant, index, self) => {
           return index === self.findIndex((t) => (t !== null && attendant !== null) && t.id === attendant.id)
          }
          );
          this.setState({
            isLoadedSections: true,
            sections: result,
            attendants: attendants,
            errorSections: null,
          }, () => {this.retrieveAttendants()});
        },
        error => {
          this.setState({
            isLoadedSections: false,
            errorSections: true,
          });
        }
      );
  }
  
  retrieveReservations() {
    getReservations()
      .then(
        result => {
          let reservations = result;
          this.setState({
            reservations: reservations,
            isLoadedReservations: true,
            errorReservations: null,
          });
        },
        error => {
          this.setState({
            isLoadedReservations: false,
            errorReservations: error
          });
        }
      );
  }
  playNotificationSound() {
    this.notificationSound.play();
  }
  playNotificationSoundForAttendant(roomId) {
    let selectedAttendant = this.state.selectedAttendant;
    if ( selectedAttendant ) {
      let room = this.state.rooms.filter(room=>room.id===roomId)[0];
      if ( room.section.attendant.id === selectedAttendant.id ) {
        this.playNotificationSound();
      }
    } else {
      this.playNotificationSound();
    }
  }
  handleNewSupplyRequest(id) {
    this.playNotificationSoundForAttendant(id);
  }
  handleNewReadyForMikvah(id) {
    this.playNotificationSoundForAttendant(id);
  }
  handleSectionsUpdated() {
    this.retrieveSections();
    console.log('sections updated');
  }
  handleChangeStatus(roomId, status, reservationStatus) {
    this.setState({
      isUpdatingStatus: true,
    })
    updateRoomStatus(roomId, status, reservationStatus)
    .then(
      result => {
        this.retrieveRooms();
      },
      error => {
        this.setState({
          error
        });
      }
    ).finally(() => 
      this.setState({
        isUpdatingStatus: false,
      })
    );
  }
  render() {
    const {settings} = this.context;
    const { t, i18n, show } = this.props;
    const { isLoadedRooms, isLoadedSections, rooms, savedRoomTime, sections, reservations, error, supplyRequests, allAttendants, showUpcomingReservations, isUpdatingStatus } = this.state;
    return (
      (settings && settings.attendantsShowTasksOnReception && settings.attendantsShowTasksOnReception.value==="True") || show?
      <>
      <div className="view-tasks-extension">
        <SignalR setReception={true} onRoomsUpdated={() => this.retrieveRooms()} setReservations={true} onReservationsUpdated={() => this.retrieveReservations()} onNewSupplyRequest={(id) => this.handleNewSupplyRequest(id)} onNewReadyForMikvah={(id) => this.handleNewReadyForMikvah(id)} onSectionsUpdated = { () => this.handleSectionsUpdated() } />
        <div className={'container-page view-attendant-tablet view-tablet lang-' + i18n.language}>
          <div className="container-main">
            <div className="container-body">
              <React.Fragment>
                <div className="sidebar-top">
                  {(
                    error !== null ?
                      <Alert color="danger">{t(error)} <span className="alert-link mis-2" onClick={()=>window.location.reload()}>{t("Try again")}</span></Alert>
                    :
                      isLoadedRooms ?
                        <div>
                          {showUpcomingReservations?
                            <div>
                              <h3>{t("Upcoming")}</h3>
                              <table className="table text-start">
                                <thead>
                                  <tr>
                                    <th>{t("Code")}</th>
                                    <th>{t("Time")}</th>
                                    <th>{t("Status")}</th>
                                    <th>{t("Room Type")}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {reservations?
                                    reservations.upcoming.length?
                                      reservations.upcoming.map((res,i) => {
                                        return <tr key={i}>
                                          <td>
                                            {res.reservationCode}{res.user.testUser?<small className="text-muted"> {t("Test")}</small>:null}
                                            {res.firstTime?
                                              <>
                                                <sup><FontAwesomeIcon className="mis-2 text-orange small" icon="asterisk" id={`icon-new-user-${res.reservationCode}`} /></sup>
                                                <UncontrolledTooltip target={`icon-new-user-${res.reservationCode}`}>{t("New Patron")}</UncontrolledTooltip>
                                              </>
                                            :null}
                                            </td>
                                          <td><Moment format={t("h:mma")}>{res.reservationTime}</Moment></td>
                                          <td>{t(statuses[res.reservationStatus].name)}</td>
                                          <td>
                                            <FontAwesomeIcon icon={res.kallah?['far','gem']:res.roomType} id={"room-type-icon-"+i} />
                                            {res.parking?<FontAwesomeIcon className="icon mis-2" icon="car" />:null}
                                            {res.doubleSlot?<FontAwesomeIcon className="icon mis-2" icon={["far", "clock"]} />:null}
                                            {res.salonManicure||res.salonBoth?<FontAwesomeIcon className="icon mis-2" icon="paint-brush" />:null}
                                          </td>
                                          <td>
                                            {res.notes!=null||res.user.notes?<FontAwesomeIcon icon={['far', 'sticky-note']} />:null}
                                            {res.user.excludedAttendants && res.user.excludedAttendants.length>0?<ReactSVG className="icon-excluded" src={iconExcludedAttendant} alt="Excluded Attendant Icon"/>:null}
                                            </td>
                                        </tr>
                                      })
                                    :<tr>
                                      <td colSpan="4" className="text-center">{t("No upcoming reservations.")}</td>
                                    </tr>
                                  :null}                          
                                </tbody>
                              </table>
                            </div>
                          :null}
                          <AttendantListView isLoadedRooms={rooms} attendantTablet={true} noScreensaver={true} rooms={rooms} savedRoomTime={savedRoomTime} handleChangeStatus={this.handleChangeStatus} isUpdatingPrepStatus={isUpdatingStatus} isLoadedSections={isLoadedSections} sections={sections} isLoadedAttendants={allAttendants} attendants={allAttendants} supplyRequests={supplyRequests} id={this.props.id} />
                        </div>
                      : <Loader />
                    )
                  }
                </div>
              </React.Fragment>
            </div>
          </div>
          <div className="container-sidebar">
          </div>
        </div>
      </div>
      </>
      :null
    );
  }
}
export default withTranslation()(ReceptionAttendantTasksView);